import React, { Component } from 'react';
import TwoColumnTable from '../TwoColumnTable';
import ContentOutline from '../ContentOutline';

import sharedStyles from '../sharedStyles.scss';

const EXAM_SUMMARY = [
  {
    topic: 'Knowledge of Capital Markets',
    description:
      'The basics, laws, and regulations of the financial markets. You’ll need to know the primary and secondary markets, the regulators (SEC and FINRA), and their rules (Act of 1933, etc).',
    weight: '12 questions, 16%',
  },
  {
    topic: 'Understanding Products and their Risks',
    description:
      'The products of the financial markets, which include stocks, bonds, mutual funds, ETFs, and options. You’ll need to know what these products are, the risks of investing in them, and how they benefit investors.',
    weight: '33 questions, 44%',
  },
  {
    topic: 'Understanding Trading, Customer Accounts and Prohibited Activities',
    description:
      'How customers buy and sell securities in their accounts. You’ll need to know different types of orders and accounts, how those orders are entered into the market, and the regulations that govern these activities.',
    weight: '23 questions, 31%',
  },
  {
    topic: 'Overview of Regulatory Framework',
    description:
      'How financial professionals operate in their jobs and the rules that govern their activities. You’ll need to know FINRA and SEC rules, ethics of working with clients, and general procedures for financial professionals.',
    weight: '7 questions, 9%',
  },
];

class FinraSie extends Component {
  render() {
    const { currentUser, product, inflatedContent } = this.props;

    return (
      <div className={sharedStyles.layout}>
        <div className={sharedStyles.title}>
          Securities Industry Essentials{' '}
          <span className={sharedStyles.shortTitle}>(FINRA SIE)</span>
        </div>
        <div className={sharedStyles.explanation}>
          <div className={sharedStyles.blurb}>
            The SIE covers the fundamentals that you&apos;ll need for any role in finance,
            regardless of the specific field you might want to specialize in.
          </div>
          <div className={sharedStyles.facts}>
            <ul>
              <li>
                <em>Time</em> 1 hour and 45 minutes
              </li>
              <li>
                <em>Format</em> 75 multiple choice
              </li>
              <li>
                <em>Passing score</em> 70% (53/75)
              </li>
              <li>
                <em>Exam fee</em> $80
              </li>
              <li>
                <em>Details</em>{' '}
                <a
                  href="https://www.finra.org/registration-exams-ce/qualification-exams/securities-industry-essentials-exam"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  FINRA <i className="fad fa-external-link" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <TwoColumnTable title="FINRA's exam summary" records={EXAM_SUMMARY} />

        <ContentOutline
          currentUser={currentUser}
          product={product}
          inflatedContent={inflatedContent}
        />
      </div>
    );
  }
}

export default FinraSie;
